module.exports = __webpack_public_path__ + "static/media/Header1.5c0e8a01.jpg";